import "babel-polyfill";
import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuex from "vuex";
import VueRouter from "vue-router";
import ElementUI from "element-ui";

import VueProgressBar from "vue-progressbar";
import DlgDraggable from "vue-element-dialog-draggable";
import Vue2Filters from "vue2-filters";
import moment from "moment";
import VueMoment from "vue-moment";
import VueTheMask from "vue-the-mask";
import config from './config'

import "animate.css";
import "element-ui/lib/theme-chalk/index.css";

ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Dialog.props.closeOnPressEscape.default = false;
ElementUI.FormItem.props.showMessage.default = false;
ElementUI.Pagination.props.layout.default = "total, prev, pager, next,sizes";

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(ElementUI, {size: "compact", zIndex: 3000});
Vue.use(Vuex);
Vue.use(Vue2Filters);

Vue.use(VueMoment, {moment});
Vue.use(VueProgressBar, {thickness: "3px"});
Vue.use(DlgDraggable);
Vue.use(VueTheMask)

//执行基本配置
window.location.hash = "";
let lang = window.localStorage.getItem("lang") || config.lang;
moment.locale(lang);
Vue.config.lang = lang;


